import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 21H5a1 1 0 01-1-1v-9H1l10.33-9.39a1 1 0 011.34 0L23 11h-3v9a1 1 0 01-1 1zM6 19h12V9.16L12 3.7 6 9.16V19z"/>
    <path fill="#34CEFF" d="M16 15H8v2h8v-2z"/>
  </SvgIcon>
);